<template><finance-document-page document-type="expense" /></template>
<script>
import FinanceDocumentPage from '../components/FinanceDocumentPage'
export default { name: 'ErpFinanceExpense', components: { FinanceDocumentPage } }
</script>
